import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DeliveryModuleState } from '../models/delivery.model';

export const getDeliveryModuleState = createFeatureSelector<DeliveryModuleState>('deliveryModule');

export const getDeliveryLines = createSelector(
  getDeliveryModuleState,
  (state) => state.deliveryLines,
);

export const getDeliveryUpdating = createSelector(
  getDeliveryModuleState,
  (state) => state.isUpdating,
);
